function updateCartCounter() {
fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
    const count = cart.item_count;
    const el = document.getElementById('cart-counter');
    if (count > 0) {
        el.textContent = count > 99 ? '99+' : count;
        el.style.display = 'inline-block';
    } else {
        el.style.display = 'none';
    }
    });
}

document.addEventListener('DOMContentLoaded', updateCartCounter);

document.addEventListener('cart:refresh', updateCartCounter);

document.addEventListener('click', function (e) {
    if (e.target.closest('xo-cart-add') || e.target.closest('.qsc2-product-item__remove-btn') ) {
        setTimeout(updateCartCounter, 800);
    }
});
